import React from 'react';
import { ClickStreamContext } from './context';

import { LogPageEventProps } from './ClickStreamModel';
import useUserData from 'hooks/useUserData';
import { clickStream, ClickStreamVersion } from 'utils/clickStream';

function getCookie(name: string) {
  let matches = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'),
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

const MANAGER_USER_TYPE = 'manager';
const EVENT_SOURCE = 'municipality';

const getCabmunCcontentUUID = () => getCookie('_cabinet_municipality_content_user_uuid');


const ClickStreamProvider = (props: any) => {
  const userData = useUserData();
  const host = process.env.REACT_APP_CLICKSTREAM_HOST;
  const userType = userData?.userType || 'Guest'; //document.querySelector<any>('meta[name="user-type"]')?.content || 'Guest';
  const userId = userData?.id || 0; // parseInt(document.querySelector<any>('meta[name="user-id"]')?.content) || 0;
  const sendingAllowed = host && userData?.type !== MANAGER_USER_TYPE;
  const sendBeacon = navigator ? true : false

  const logPageEvent = ({
    eventInfo,
    eventType,
    eventSource = EVENT_SOURCE,
    cd1 = '',
    cd2 = '',
    cd3 = getCabmunCcontentUUID() || '',
  }: LogPageEventProps) => {

    const data = {
      userId,
      userType,
      eventType,
      eventInfo,
      eventSource,
      customDimentions: { cd1: cd1.toString(), cd2: cd2.toString(), cd3: cd3.toString() },
    }

    console.log('EventsDebug: ', `@@ uchiru.page_events (${sendingAllowed ? '+ allowed' : '- prohibi'}) @@`, data);

    if (sendingAllowed) {
      clickStream(ClickStreamVersion.Events).pageEvent(data, { sendBeacon: sendBeacon });
    }
  };

  const logViewPage = ({ cd1 = '', cd2 = '', cd3 = getCabmunCcontentUUID() || '' }: any = {}) => {
    try {
      const data = {
        userId,
        userType,
        customDimentions: {
          cd1: cd1.toString(),
          cd2: cd2.toString(),
          cd3: cd3.toString(),
        }
      }
      console.log('EventsDebug: ', `@@ uchiru.pageviews (${sendingAllowed ? '+ allowed' : '- prohibi'}) @@`, data);

      if (sendingAllowed) {
         clickStream(ClickStreamVersion.Views).pageView(data);
      }
      //eslint-disable-next-line no-empty
    } catch (e) { }
  };
  return (
    <ClickStreamContext.Provider value={{ logViewPage, logPageEvent }}>{props.children}</ClickStreamContext.Provider>
  );
};
export default ClickStreamProvider;
